import React, { useMemo, useCallback } from 'react';

import { __t } from '../../../../../base/utils/t';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { Button } from '../../../../../base/components/Button';
import { Icon } from '../../../../../base/components/Icon';
import { vacancyFormActions } from '../../redux/slices/vacancyFormSlice';

import './styles.scss';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
    previewClickHandler: () => void;
}

export const Footer = ({ previewClickHandler }: Props) => {
    const dispatch = useAppDispatch();
    const {
        vacancyForm: { step },
        app: { referrer },
    } = useAppSelector((state) => state);
    const location = useLocation();
    const navigate = useNavigate();

    const prevStepClickHandler = () => dispatch(vacancyFormActions.setStep(step - 1));

    const nextStepClickHandler = () => dispatch(vacancyFormActions.nextStep());

    const onBackClick = useCallback(() => {
        if(location.state?.from?.pathname) {
            navigate(location.state?.from?.pathname);
            return;
        }
        if (referrer) {
            window.location.href = referrer;
            return;
        }
        return;
    }, [step, referrer, location]);

    const progressWidth = useMemo((): string => {
        switch (step) {
            case 1:
                return '25%';
            case 2:
                return '50%';
            case 3:
                return '75%';
            case 4:
                return '100%';
            default:
                return '0%';
        }
    }, [step]);

    const prevButton = useMemo(() => {
        if (step === 1) {
            return (
                <Button className='vacancy-form-footer__button' type='link' onClick={onBackClick}>
                    {__t('Выйти')}
                </Button>
            );
        }

        return (
            <Button className='vacancy-form-footer__button' type='link' onClick={prevStepClickHandler}>
                {__t('Назад')}
            </Button>
        );
    }, [step, onBackClick, prevStepClickHandler]);

    const nextButton = useMemo(() => {
        if (step === 4) {
            return (
                <div className='vacancy-form-footer__confirmation-buttons'>
                    <Button
                        className='vacancy-form-footer__button vacancy-form-footer__preview-button'
                        type='secondary'
                        onClick={previewClickHandler}
                    >
                        <Icon icon='eye-solid' color='danger' className='vacancy-form-footer__button-preview-icon' />
                        {__t('Предварительный просмотр')}
                    </Button>
                    <Button className='vacancy-form-footer__button' onClick={nextStepClickHandler}>
                        {__t('Опубликовать')}
                    </Button>
                </div>
            );
        }

        return (
            <Button className='vacancy-form-footer__button' onClick={nextStepClickHandler}>
                {__t('Далее')}
                <Icon
                    className='vacancy-form-footer__button-icon'
                    icon='arrow-right-long-solid'
                    color='white'
                    size='15'
                />
            </Button>
        );
    }, [step, previewClickHandler]);

    return (
        <div className='vacancy-form-footer'>
            <div className='app-progress-bar'>
                <span className='app-progress-bar__progress' style={{ width: progressWidth }}></span>
            </div>
            <div className='vacancy-form-footer__buttons-wrap'>
                {prevButton}
                {nextButton}
            </div>
        </div>
    );
};
